import { faEdit, faMagnifyingGlass, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import AlertDialogSlide from '../../Common/DeleteDialog'
import { useDispatch, useSelector } from 'react-redux'
import { addProvider, deleteProvider, getProvider, searchProvider, updateProvider } from '../../Redux/Actions/DashOptions'
import { toast } from 'react-toastify'
import Loader from '../../Common/Loader'
import FormAdd from '../../Common/FormAdd'
import Pagination from '../../Common/Pagination'
import { capitalizeFirstLetter } from '../../Utils/helper'
import { debounce } from 'lodash'
import { Circles } from 'react-loader-spinner'

const AddProvider = () => {
    const dispatch = useDispatch()

    const getProviderData = useSelector((state) => state?.DashOptionsSlice?.listdata?.data) // get data for listing
    const getListingLoading = useSelector((state) => state?.DashOptionsSlice?.isLoading)    // get lisitng loading
    const getSearchedData = useSelector((state) => state?.DashOptionsSlice?.providerSearched?.data)    // get lisitng loading
    const searchedDataLoading = useSelector((state) => state?.DashOptionsSlice?.isLoading)    // get lisitng loading

    const { current_page, last_page, } = useSelector((state) => state?.DashOptionsSlice?.listdata || {}); // getting pagination
    const searchPaginationData = useSelector((state) => state?.DashOptionsSlice?.providerSearched || {}); // getting pagination

    const [open, setOpen] = React.useState(false);
    const [openAddForm, setOpenAddForm] = useState(false)
    const [page, setPage] = useState(current_page || 1);
    const [loading, setLoading] = useState(false)
    const [deleteId, setDeleteID] = useState()
    const [itemForEdit, setItemForEdit] = useState()
    const [searchValue, setSearchValue] = useState("")

    const options = [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
    ]
    const handleSubmit = (values, form) => {
        if (!itemForEdit) {
            setLoading(true)
            const formData = new FormData()
            formData.append('name', values.name);
            formData.append('status', values.status);
            dispatch(addProvider(formData)).then((res) => {
                setLoading(false)
                if (res.payload?.id) {
                    setOpenAddForm(false)
                    dispatch(getProvider({ page: page }))
                    toast.success('Successfully added')
                } else if (res?.type === "provider/rejected") {
                    toast.error('Provider already exists')
                } else {
                    toast.error(res?.message || 'An error occured')
                }
                form.reset()
            })
        } else {

            const payload = {
                name: values.name, status: values.status
            }
            setLoading(true)
            dispatch(updateProvider({ id: itemForEdit.id, payload })).then((res) => {
                setLoading(false)
                if (res.payload?.id) {
                    setOpenAddForm(false)
                    dispatch(getProvider({ page: page }))
                    toast.success('Successfully Updated')
                } else if (res?.type === "provider/rejected") {
                    toast.error('Provider already exists')
                } else {
                    toast.error(res?.message || 'An error occured')
                }
                form.reset()
            })
        }

    }

    const validate = (values) => {
        const error = {}
        if (!values.name) {
            error.name = "Required"
        }
        return error
    }

    const initialValues = useMemo(() => {
        if (itemForEdit) {
            return {
                name: itemForEdit?.name || "",
                status: itemForEdit?.status || "", // You had itemForEdit?.name again
            };
        }
        return {
            name: "",
            status: "",
        };
    }, [itemForEdit]);

    const handleBack = () => {
        setItemForEdit('')
        setOpenAddForm(false)
    }

    const handleDelete = (selectedID) => {
        setOpen(true)
        setDeleteID(selectedID)
    }

    const handleDeleteByModal = () => {
        dispatch(deleteProvider(deleteId)).then((res) => {
            if (res?.payload) {
                toast.success(res?.payload?.message)
                setOpen(false);
                dispatch(getProvider({ page: page }))
            } else {
                toast.error('An error occured')
            }
        })
    }
    const handleFormModal = () => {
        setOpenAddForm(true)
    }

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const handleEdit = (selectedItem) => {
        setOpenAddForm(true)
        setItemForEdit(selectedItem)
    }

    const debouncedSearch = useMemo(() => debounce((query) => {
        if (query.trim() === "") {
            dispatch(searchProvider({ field: "", value: "" }));
            dispatch(getProvider({ page: page }));
            setPage(current_page || 1);
        } else {
            setPage(searchPaginationData?.current_page || 1)
            dispatch(searchProvider({ field: "name", value: query }));
        }
    }, 500), [dispatch]);


    const handleSearch = useCallback((e) => {
        const value = e.target.value;
        setSearchValue(value);
        debouncedSearch(value);
    }, [debouncedSearch]);

    const isSearching = useMemo(() => searchValue.trim() !== "", [searchValue]);

    useEffect(() => {
        if (searchValue?.trim() === "") {
            dispatch(getProvider({ page: page }));
        }
    }, [page, searchValue, dispatch]);

    return (
        <div className="min-h-screen bg-gray-100 p-6">
            {!isSearching && (loading || getListingLoading) && <Loader />}
            <div className="mx-auto space-y-8">
                <div className="bg-white shadow-xl rounded-xl p-8">
                    <div className="mt-2">
                        <div className="flex justify-between items-center mb-4">
                            <div>
                                <h3 className="text-xl font-semibold text-gray-800 mb-4">Provider</h3>
                                <div className="relative flex items-center">
                                    <span className="absolute left-3 text-gray-400">
                                        <FontAwesomeIcon icon={faMagnifyingGlass} />
                                    </span>
                                    <input
                                        type="text"
                                        placeholder="Search Provider..."
                                        onChange={(e) => handleSearch(e)}
                                        className="pl-10 pr-4 py-2 w-full sm:w-80 md:w-96 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                    />
                                </div>
                            </div>
                            <button
                                onClick={handleFormModal}
                                className="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-md shadow-md transition duration-300 ease-in-out flex items-center space-x-2"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-5 w-5"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                >
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
                                </svg>
                                <span>Add Provider</span>
                            </button>
                        </div>

                        <table className="min-w-full divide-y divide-gray-200 text-sm">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th className="px-2 py-3 text-left font-semibold text-gray-600 uppercase tracking-wider">Name</th>
                                    <th className="px-2 py-3 text-left font-semibold text-gray-600 uppercase tracking-wider">Status</th>
                                    <th className="px-6 py-3 text-center font-semibold text-gray-600 uppercase tracking-wider">Actions</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {searchedDataLoading && isSearching ? (
                                    <tr>
                                        <td colSpan="3" className="text-center py-6 text-gray-500">
                                            <div className="flex justify-center items-center h-40">
                                                <Circles
                                                    height="80"
                                                    width="80"
                                                    color="#2563EB"
                                                    ariaLabel="circles-loading"
                                                    visible={true}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ) : isSearching ? (
                                    getSearchedData && getSearchedData?.length > 0 ? (
                                        getSearchedData.map((item, index) => (
                                            <tr className="hover:bg-gray-50 transition" key={index}>
                                                <td className="px-3 py-3 whitespace-nowrap text-gray-900">{capitalizeFirstLetter(item?.name)}</td>
                                                <td className="px-3 py-3 text-left whitespace-nowrap">
                                                    <span className={`px-3 py-1 rounded-full text-sm font-medium ${item?.status === 'active'
                                                        ? 'bg-green-100 text-green-700'
                                                        : 'bg-red-100 text-red-700'
                                                        }`}>
                                                        {capitalizeFirstLetter(item?.status)}
                                                    </span>
                                                </td>
                                                <td className="px-3 py-3 text-center whitespace-nowrap">
                                                    <div className="flex justify-center space-x-3">
                                                        <button className="text-yellow-500 hover:text-blue-600" onClick={() => handleEdit(item)}>
                                                            <FontAwesomeIcon icon={faEdit} />
                                                        </button>
                                                        <button onClick={() => handleDelete(item?.id)} className="text-red-500 hover:text-red-600">
                                                            <FontAwesomeIcon icon={faTrash} />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="3" className="text-center py-6 text-gray-500">
                                                No search results found.
                                            </td>
                                        </tr>
                                    )
                                ) : (
                                    getProviderData && getProviderData?.length > 0 ? (
                                        getProviderData.map((item, index) => (
                                            <tr className="hover:bg-gray-50 transition" key={index}>
                                                <td className="px-3 py-3 whitespace-nowrap text-gray-900">{capitalizeFirstLetter(item?.name)}</td>
                                                <td className="px-3 py-3 text-left whitespace-nowrap">
                                                    <span className={`px-3 py-1 rounded-full text-sm font-medium ${item?.status === 'active'
                                                        ? 'bg-green-100 text-green-700'
                                                        : 'bg-red-100 text-red-700'
                                                        }`}>
                                                        {capitalizeFirstLetter(item?.status)}
                                                    </span>
                                                </td>
                                                <td className="px-3 py-3 text-center whitespace-nowrap">
                                                    <div className="flex justify-center space-x-3">
                                                        <button className="text-yellow-500 hover:text-blue-600" onClick={() => handleEdit(item)}>
                                                            <FontAwesomeIcon icon={faEdit} />
                                                        </button>
                                                        <button onClick={() => handleDelete(item?.id)} className="text-red-500 hover:text-red-600">
                                                            <FontAwesomeIcon icon={faTrash} />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="3" className="text-center py-6 text-gray-500">
                                                No data available.
                                            </td>
                                        </tr>
                                    )
                                )}
                            </tbody>

                        </table>
                        <div className="mt-2 flex justify-end">
                            <Pagination
                                count={!isSearching ? last_page : searchPaginationData?.last_page}  // total pages
                                page={page}         // current page
                                onPageChange={handlePageChange}  // handler
                            />
                        </div>
                    </div>
                </div>

            </div>
            <AlertDialogSlide open={open} setOpen={setOpen} handleDeleteByModal={handleDeleteByModal} />
            <FormAdd validate={validate} initialValues={initialValues} handleBack={handleBack} options={options} handleSubmit={handleSubmit} setOpenAddForm={setOpenAddForm} openAddForm={openAddForm} />
        </div>
    )
}

export default AddProvider
